var React = require('react');

function EcommSingleDay (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29.8,4.2h-4.2l0-2.1c0-1.2-1-2.1-2.1-2.1c-1.2,0-2.1,1-2.1,2.1v2.1l-8.5,0V2.1c0-1.2-1-2.1-2.1-2.1C9.5,0,8.5,1,8.5,2.1\r\n\tv2.1l-4.2,0C1.9,4.2,0,6.2,0,8.5v21.2C0,32.1,1.9,34,4.2,34h25.5c2.3,0,4.2-1.9,4.2-4.2l0-21.2C34,6.2,32.1,4.2,29.8,4.2L29.8,4.2z\r\n\t M29.8,29.8H4.2V11.7h25.5L29.8,29.8z","key":0}),React.createElement("path",{"d":"M20.6,25.8H14v-1.9h2.3v-6.6H14v-1.9h4.5v8.5h2.1V25.8z","key":1})]);
}

EcommSingleDay.defaultProps = {"role":"presentation","version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 34 34","style":{"enableBackground":"new 0 0 34 34"},"xmlSpace":"preserve"};

module.exports = EcommSingleDay;

EcommSingleDay.default = EcommSingleDay;
